<template>
  <customer-list-card />
</template>

<script lang="ts" setup>
import customerListCard from "@/customers/components/customer/customerListCard.vue";
</script>
